var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v("* "+_vm._s(_vm._traducao('global', 'semana'))+":")]),_vm._v(" "),_c('v-select',{staticClass:"form-control",attrs:{"type":"number","options":_vm.listaSemanas,"label":"semana"},model:{value:(_vm.form.semana),callback:function ($$v) {_vm.$set(_vm.form, "semana", $$v)},expression:"form.semana"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }